import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { SectionLabel, Reveal } from "./primitives";
import { usePricing } from "@/lib/pricing";

const faqs = [
  {
    q: "Wie viel Zeit muss ich einplanen?",
    a: "Du bestimmst Dein Tempo selbst: Die Module kannst Du ‚live‘ mitmachen oder in Deinem eigenen Rhythmus durchlaufen. Die Live Calls sind Angebote, keine Pflicht – alle werden aufgezeichnet, sodass Du nichts verpasst und flexibel bleibst. Wenn Du live mitmachst, plane Dir für die ersten 3 Monate ca. 1-2 Stunden neben den Live Sessions pro Woche ein.",
  },
  {
    q: "Was ist, wenn ich bei einem Call nicht live dabei sein kann?",
    a: "Alle Live Calls finden über Zoom statt und werden aufgezeichnet. Du kannst sie Dir jederzeit nochmal anschauen, auch wenn Du mal nicht live dabei bist. Im Vorfeld der Coaching- und Q&A-Sessions werden Fragen eingesammelt, so dass Du Deine Frage auch beantwortet bekommst, wenn Du nicht live dabei bist. Beim Telegram Tag antwortet Luisa persönlich per Sprachnachricht - ganz unabhängig von festen Zeiten.",
  },
];

const paymentFaq = (priceLabel, founding) => ({
  q: "Wie kann ich zahlen?",
  a: `Die Investition beträgt ${priceLabel}${founding ? " (Founding Member)" : ""}. Du kannst per Einmalzahlung oder bequem in 3 bzw. 6 Raten zahlen. Die Buchung läuft ganz einfach über die Checkout-Seite - per Kreditkarte oder Paypal.`,
});

const FAQItem = ({ faq, index }) => (
  <AccordionItem
    value={`faq-${index}`}
    className="border-t border-cognac/30 border-b-0"
    data-testid={`faq-item-${index}`}
  >
    <AccordionTrigger
      data-testid={`faq-trigger-${index}`}
      className="py-7 text-left font-heading text-lg font-600 uppercase tracking-tight text-espresso hover:no-underline hover:text-cognac-2 md:text-xl [&>svg]:text-cognac-2"
      style={{ fontWeight: 600 }}
    >
      {faq.q}
    </AccordionTrigger>
    <AccordionContent className="pb-8">
      <p className="max-w-2xl font-body text-lg leading-[1.75] text-[#241a15]">
        {faq.a}
      </p>
    </AccordionContent>
  </AccordionItem>
);

export default function FAQ() {
  const { priceLabel, founding } = usePricing();
  const allFaqs = [...faqs, paymentFaq(priceLabel, founding)];
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative w-full bg-paper py-24 md:py-36"
    >
      <div className="mx-auto max-w-6xl px-6 md:px-12">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-4">
            <SectionLabel testId="faq-label">FAQ</SectionLabel>
            <Reveal>
              <h2
                className="font-heading text-3xl font-700 uppercase leading-[1.05] tracking-[-0.01em] text-espresso md:text-5xl"
                style={{ fontWeight: 700 }}
              >
                Häufige Fragen
              </h2>
            </Reveal>
          </div>
          <div className="md:col-span-8">
            <Reveal delay={0.08}>
              <Accordion type="single" collapsible className="w-full">
                {allFaqs.map((f, i) => (
                  <FAQItem key={f.q} faq={f} index={i} />
                ))}
              </Accordion>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
